import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Things I've Done`}</h2>
    <ProjectCard title="BitPerks" link="https://bitperks.net/" bg="linear-gradient(to right, #7790F0 0%, #E24C86 100%)" mdxType="ProjectCard">
This is a project I Co-Founded that allowes you to monitize your social tokens (through $DeSo) with rewards, and perks for your token holders.
    </ProjectCard>
    <ProjectCard title="BlockPerks" link="https://blockperks.net/" bg="linear-gradient(to right, #000000 0%, #004AAD 100%)" mdxType="ProjectCard">
This is a project I Co-Founded that allows creators to monetize their following using social tokens and rewarding their fans with NFT's, exclusive content and more.
    </ProjectCard>
    <ProjectCard title="InnerCircle" link="https://discord.gg/MYEFJmqVea" bg="linear-gradient(to right, #5CE1E6 0%, #38B6FF 100%)" mdxType="ProjectCard">
This is commmunity that we created, through Discord, to help you reach your goals and stay accountable, all while making amazing connections.
    </ProjectCard>
    <ProjectCard title="Started a Blog" bg="linear-gradient(to right, #FFBD59 0%, #FFDE59 100%)" mdxType="ProjectCard">
This project is still in stelth mode, more information coming soon.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      